/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService
 */

/**
 * Virtual record for map with known enum keys
 */

export let ComHubspotCvThreadsDraftsRpcModels;
(function (_ComHubspotCvThreadsDraftsRpcModels) {})(ComHubspotCvThreadsDraftsRpcModels || (ComHubspotCvThreadsDraftsRpcModels = {}));
export let ComHubspotCvThreadsDraftsRpcModelsV2;
(function (_ComHubspotCvThreadsDraftsRpcModelsV) {})(ComHubspotCvThreadsDraftsRpcModelsV2 || (ComHubspotCvThreadsDraftsRpcModelsV2 = {}));
export const upsertDraftRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'upsertDraft',
  auth: 'app',
  fingerprint: 'ID3o2Ti988rsqKfr0PbPbBcytmmHPtEY',
  na1Only: false,
  isStreaming: false
};
export const deleteDraftRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'deleteDraft',
  auth: 'app',
  fingerprint: 'pBh-fQEujYM5wDdkU00U2rRolttlYLrU',
  na1Only: false,
  isStreaming: false
};
export const getDraftsRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'getDrafts',
  auth: 'app',
  fingerprint: 'EQqM1mLno9-cL53E_VA-y6smjQbTWC6f',
  na1Only: false,
  isStreaming: false
};